const ExternalTeacherStatistics = () =>
  import('@/views/main/externalStatistics/externalTeacherStatistics/ExternalTeacherStatistics.vue')
export default {
  path: '/main/externalStatistics/externalTeacherStatistics',
  name: 'ExternalTeacherStatistics',
  component: ExternalTeacherStatistics,
  children: []
}
